import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import CoinSelect from "../../components/selectComponents/coinSelect.vue";
import timeDateOptions from "../../components/timeList/timeDateOptions.vue";
import serverList from "../../components/serverList/serverOptions.vue";
import compCoin from "./components/compCoin.vue";
import { getGameServerMap, getReasonMap, getGameCoinMap } from "@/utils/dictionary";
export default {
  components: {
    serverList: serverList,
    compCoin: compCoin,
    CoinSelect: CoinSelect,
    timeDateOptions: timeDateOptions
  },
  name: "currencyLog",
  data: function data() {
    return {
      serverList: {},
      reasonList: {},
      reasonArray: [],
      coinList: {},
      coinTypeLists: [],
      timedata: [this.$moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")],
      searchInfo: {
        coin_type: "1",
        changeType: 0
      },
      changeTypeOption: [{
        ID: 0,
        val: "全部"
      }, {
        ID: 1,
        val: "获得"
      }, {
        ID: -1,
        val: "消耗"
      }]
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _index, index;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              getGameServerMap().then(function (res) {
                _this.serverList = res;
              });
              _context.next = 3;
              return getReasonMap();
            case 3:
              _this.reasonList = _context.sent;
              for (_index in _this.reasonList) {
                _this.reasonArray.push({
                  id: _index,
                  name: _this.reasonList[_index]
                });
              }
              _context.next = 7;
              return getGameCoinMap();
            case 7:
              _this.coinList = _context.sent;
              for (index in _this.coinList) {
                _this.coinTypeLists.push({
                  id: index,
                  desc: _this.coinList[index]
                });
              }
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    queryEvent: function queryEvent(e) {
      this.searchInfo.sdate = this.timedata[0];
      this.searchInfo.edate = this.timedata[1];
      if (e == "search") {
        this.$refs.myChild.goMethod("1", this.searchInfo);
      } else {
        this.$refs.myChild.goMethod("2", this.searchInfo);
      }
    }
  }
};